import { createFileRoute } from '@tanstack/react-router'
import { requireRoles } from '@/lib/middleware'
import { Claims } from '@/features/claims'
import z from 'zod'

const claimsSearchSchema = z.object({
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(10),
  clientId: z.string().optional().catch(''),
  status: z.array(z.string()).optional().catch([]),
  category: z.string().optional().catch(''),
})

export const Route = createFileRoute('/_authenticated/_organization/claims/')({
  validateSearch: claimsSearchSchema,
  beforeLoad: async () => requireRoles(['owner', 'admin', 'finance']),
  component: Claims,
})
